<div class="comp-title-page">
    <div class="row">
        <!-- title -->
        <div class="col-lg-7 col-md-6 left order-md-1 order-2">
            <div class="position-relative h-100">
                <div class="w-title mb-md-0" 
                    [ngClass]="{'ver-1': dataTitle?.icon, 'mb-4': dataTitle?.description }">
                    <img class="icon" 
                        [src]="apiAsset + dataTitle?.icon" 
                        alt="" 
                        *ngIf="dataTitle?.icon">
                    <h2 class="fw-400 mb-0" [innerHTML]="dataTitle?.title"></h2>
                </div>
                <!-- <div class="d-md-block w-detail mt-md-0 mt-5 d-flex align-items-end">
                    <div class="scroll-down pt-md-4 pb-md-5 pb-4 text-right">
                        <app-scroll [color]="'blue'" [link]="link"></app-scroll>
                    </div>
                    <div class="text-justify pr-md-0 pr-4">
                        <ng-content></ng-content>
                        <div class="desc" [innerHTML]="dataTitle?.description"></div>
                    </div>
                </div> -->
                <div class="scroll-down d-md-block d-none pt-md-4 pb-md-5 text-right">
                    <app-scroll [color]="'blue'" [link]="link"></app-scroll>
                </div>
                <div class="text-justify">
                    <ng-content></ng-content>
                    <div class="detail" [innerHTML]="dataTitle?.description"></div>
                </div>
            </div>
        </div>
        <!-- picture -->
        <div class="col-lg-5 col-md-6 px-md-3 px-0 right order-md-2 order-1">
            <img [src]="apiAsset + dataTitle?.picture" class="w-100" alt="">
        </div>
    </div>
</div>
